export default __webpack_public_path__ + "media/images/elements/vr-65a9bb7256c5fa836ccfe4b83418f842.png";